export const environment = {
  production: false,
  apiBase: 'https://api.teleeagle.com/',
  apiVersion: 'v1',
  xApiToken: '12OqsaXd9cxl1071Ql5IErt3C74oo5kEG',
  appName: 'hospital',
  appVersion: '3.0.1',
  SOCKET_ENDPOINT: 'https://websocket.teleeagle.com/',
  role: 'hospital',
  appLogo: 'eagle',
  teleconsultLinks: {
    provider: 'https://teleconsult.teleeagle.com/teleconsult-v2/',
    client: 'https://teleconsult.teleeagle.com/consult/',
  },
};
